import { AttendanceMarkingModalBody } from "modules";
import React from "react";
import { ModalLayout } from "shared";
import attendance from "assets/images/attendance.svg";

export const AttendanceModal = ({
  enable,
  onCheckIn,
  onClick,
  onCloseModal,
  newDate,
  attendanceMarking,
}) => {
  return (
    <ModalLayout
      isOpen={enable}
      onConfirm={onCloseModal}
      commonModalStyle={"common-modal-style"}
      modalStyle={{ maxWidth: "450px" }}
      modalBody={<AttendanceMarkingModalBody serverTime={newDate} />}
      modalButtonGroup={
        <div className="mb-3">
          <button
            type="button"
            className="btn btn-nergy-primary"
            onClick={onCheckIn}
            style={{ width: "317px" }}
            disabled={attendanceMarking.isPending}
          >
            Check In Now
          </button>
        </div>
      }
      HeaderComponent={
        <div class="modal-header p-0 ">
          <img
            src={attendance}
            width={"100%"}
            className="object-fit-contain"
            alt="Attendance"
          />
        </div>
      }
    />
  );
};
